import {
  TranslationConcretingApprovalMessages,
  ConcretingApprovalMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingApprovalMessages = {
  [ConcretingApprovalMessages.stepDetailsText]: "Detalhes",
  [ConcretingApprovalMessages.stepActionsText]: "Ações",
  [ConcretingApprovalMessages.stepMessagesText]: "Mensagens",
  [ConcretingApprovalMessages.dialogTitleText]: "Aprovar Programação",
  [ConcretingApprovalMessages.dialogButtonSubmitText]: "Confirmar",
  [ConcretingApprovalMessages.actionsStatusFieldLabel]: "Status da programação",
  [ConcretingApprovalMessages.actionsObservationFieldLabel]: "Observação",
  [ConcretingApprovalMessages.concretingRequestStatusApproved]: "Aprovada",
  [ConcretingApprovalMessages.concretingRequestStatusRejected]: "Rejeitada",
  [ConcretingApprovalMessages.concretingRequestStatusPending]: "Pendente",
  [ConcretingApprovalMessages.messageInputPlaceholder]: "Escreva uma mensagem"
};
